<app-yu-custom-item
  [isButton]="isButton"
  [title]="platform.nombre"
  [quantity]="platform.value"
  (click)="clickOpenPlatform.emit()"
>
  <div extra-note slot="start" class="square" [ngStyle]="{'background': platform.color}"></div>
</app-yu-custom-item>
